export default "__VITE_ASSET__f285865b__"